import { render, staticRenderFns } from "./ItensModal.vue?vue&type=template&id=02cc0e5a&"
import script from "./ItensModal.vue?vue&type=script&lang=js&"
export * from "./ItensModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports